import React, { useEffect, useState } from 'react';
import GlobalWrapper from '../../../../components/Wrapper/GlobalWrapper';
import { Box, Stack } from '@mui/material';
import DatePickerCustom from '../../../../components/DatePicker/DatePickerCustom';
import dayjs from 'dayjs';
import { getIncome, getIncomeScreenshot } from '../../../../redux/features/incomeSlice';
import { useDispatch, useSelector } from 'react-redux';
import { IncomeTableHeaders as columns } from '../../../../components/datagrid/myworkspace/ogd/income/IncomeTableHeaders';
import Actions from './Actions';
import AddOrUpdateIncome from '../../../../components/datagrid/myworkspace/ogd/income/AddOrUpdateIncome';
import { savePaginationData } from '../../../../redux/features/globalDatagridSlice';
import GlobalDatagrid from '../../../../components/mui/DataGrid/GlobalDatagrid';
import ActionDetails from '../../../../components/mui/GlobalAnchor/ActionDetails';
import ViewScreenShot from '../Invoice/ViewScreenShot';
import GlobalAnchorList from '../../../../components/mui/GlobalAnchor/GlobalAnchorList';
import IncomeTemplatePrint from './IncomeTemplatePrint';
import DeleteIncome from '../../../../components/datagrid/myworkspace/ogd/income/DeleteIncome';
import GlobalSelectFieldWithoutFormikNew from '../../../../components/mui/GlobalSelectFieldWithoutFormikNew';
import FromAndToDatePicker from '../../../../components/mui/FromAndToDatePicker';
import { ADDED_BY } from '../../../../utils/constants/AddedBy';

const IncomeUpdatedPagination = () => {
  const dispatch = useDispatch();
  const [selectedDate, setSelectedDate] = useState(dayjs().format('YYYY-MM'));
  const [fromDate, setFromDate] = useState(dayjs().startOf('year').format('YYYY-MM-DD'));
  const [toDate, setToDate] = useState(dayjs().endOf('year').format('YYYY-MM-DD'));

  const [addedBy, setAddedBy] = useState({
    id: '',
    label: '',
  });

  const { loading, incomeData, rowCount } = useSelector((store) => store.income);
  const { paginationData } = useSelector((state) => state.globalDataGrid);
  const { gridSize, pageNum, rowData, openAnchor, search } = paginationData;

  const paginationDetails = {
    pageNumber: pageNum,
    pageLimit: gridSize,
    selectedDate: selectedDate,
    searchValue: search,
    fromDate: fromDate,
    toDate: toDate,
    addedBy: addedBy.id,
  };

  useEffect(() => {
    dispatch(savePaginationData({ ...paginationData, pageNum: 1 }));
  }, [selectedDate, search]);

  useEffect(() => {
    dispatch(getIncome(paginationDetails));
  }, [pageNum, gridSize, selectedDate, search, fromDate, toDate, addedBy]);

  return (
    <GlobalWrapper title={'Income'} actions={<AddOrUpdateIncome />}>
      <Box mb={1}>
        <DatePickerCustom
          value={dayjs(selectedDate)}
          setValue={(date) => setSelectedDate(date.format('YYYY-MM'))}
          viewDetails={['year', 'month']}
        />
      </Box>
      {/* <Stack direction={{ xs: 'column', sm: 'row' }} gap={1}>
        <GlobalSelectFieldWithoutFormikNew
          label={'Added By'}
          selectedDetails={addedBy}
          setChange={setAddedBy}
          data={ADDED_BY}
          sx={{
            minWidth: 200,
          }}
          keys={{
            itemId: 'id',
            itemValue: 'label',
          }}
        />
        <FromAndToDatePicker fromDate={fromDate} setFromDate={setFromDate} toDate={toDate} setToDate={setToDate} />
      </Stack> */}

      <Box sx={{ mt: 2 }}>
        <GlobalDatagrid
          tableHead={columns}
          rows={incomeData}
          meta={rowCount}
          rowUniqueId="sl_no"
          loading={loading}
          rowClick={true}
          actionComponent={
            <>
              <ActionDetails val={rowData?.studentName} />
              <GlobalAnchorList
                label="Payment"
                component={<ViewScreenShot pageName="income" api={getIncomeScreenshot(rowData?.screenshotLink)} />}
              />
              <GlobalAnchorList
                label="Edit"
                component={
                  <AddOrUpdateIncome
                    isVerified={rowData?.incomeVerification}
                    paginationDetails={paginationDetails}
                    row={rowData}
                  />
                }
              />
              <GlobalAnchorList
                label="Delete"
                component={
                  <DeleteIncome
                    isVerified={rowData?.deleteButtonView}
                    paginationDetails={paginationDetails}
                    incomeId={rowData?.incomeId}
                  />
                }
              />
              <GlobalAnchorList
                label="Fee Reciept"
                component={<IncomeTemplatePrint isVerified={rowData?.incomeVerification} row={rowData} />}
              />
            </>
          }
        />
      </Box>
    </GlobalWrapper>
  );
};

export default IncomeUpdatedPagination;
